import type { CompanyArticleDetails, CompanyArticleDetailsRequest } from "@/modules/companies/api/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"
import { toSnakeCaseKeys } from "@/modules/format/object/toSnakeCaseKeys"

export const COMPANY_ARTICLE_DETAILS_QUERY_KEY = "companies::company::articles::details"
const COMPANY_ARTICLE_DETAILS_ENDPOINT =
  "/jobteaser.company.services.article.v1alpha1/ArticleService/GetArticleFromSlug"

export type CompanyArticleDetailsRedirect = {
  newPermalink: string
  responseType: "redirect"
}

export const getCompanyArticleDetails = async (
  params: CompanyArticleDetailsRequest
): Promise<CompanyArticleDetails | CompanyArticleDetailsRedirect> => {
  return fetcher(COMPANY_ARTICLE_DETAILS_ENDPOINT, {
    requestInit: {
      body: JSON.stringify(toSnakeCaseKeys(params)),
      method: "POST",
    },
    serviceDomain: "APIGW_IN_KRAKEND_API",
  })
    .then(async response =>
      getResultFromResponse<CompanyArticleDetails, CompanyArticleDetails, CompanyArticleDetailsRedirect>({
        onHttpRedirect: () => ({
          newPermalink: response.headers.get("location") || "",
          responseType: "redirect",
        }),
        transformResult: toCamelCaseKeys,
      })(response)
    )
    .catch(handleFetchError(COMPANY_ARTICLE_DETAILS_ENDPOINT, params))
}
